import React from "react";
import KnowledgeBackedProfileChapter from "./KnowledgeBackedProfileChapter";

// Safety-specific classification, grouping, and copy stay in safetyDomain.js.
// Shared Profile lifecycle stays in the reusable shell.
const ProfileSafetyChapter = (props) => (
  <KnowledgeBackedProfileChapter {...props} presentationMode="profileItems" showGroupHeadings />
);

export default ProfileSafetyChapter;
